import { render, staticRenderFns } from "./authorCmp.vue?vue&type=template&id=b43e1660&scoped=true&"
import script from "./authorCmp.vue?vue&type=script&lang=js&"
export * from "./authorCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43e1660",
  null
  
)

export default component.exports